import { OrderStatus } from "@/features/order/types.ts";

export type OrderStatusColor =
  | "default"
  | "accent"
  | "success"
  | "warning"
  | "danger";

const statusColorMap: Record<OrderStatus, OrderStatusColor> = {
  created: "default",
  cancelled: "danger",
  accepted: "accent",
  going_to_sender: "accent",
  decided: "danger",
  submitted: "accent",
  accounted: "warning",
  checked: "warning",
  revision: "warning",
  dispatched: "warning",
  transit: "accent",
  arrived: "accent",
  assigned: "accent",
  delivers_recipient: "accent",
  completed: "success",
};

export const orderStatusColor = (status: OrderStatus): OrderStatusColor =>
  statusColorMap[status] ?? "default";
